export const BASE_API_URL = process.env.NODE_ENV === "production"
    ? "https://chemical-angelita-upperqase-6332667a.koyeb.app"
    : "http://localhost:9008"
